import { useEffect, useState } from "react";
import { Grid, styled } from "@mui/material";

import { MessageSections } from "../../components/message/message";
import Message from "../../components/message";

import CardItem from "../../home/components/Card/CardItem";
import { Title } from "../../home/components/Title/Title";
import Layout from "../../home/components/Layout";

import { BlogPostModel } from "../../shared/models/blogModel";
import blogService from "../../../services/blog-service";
import Container from "../../home/components/Container";

export const CardContentWrapper = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1240px;
  gap: 16px;
  margin-bottom: 10px;
  padding: 0 20px;
`;

const BlogList = () => {
  const [data, setData] = useState<BlogPostModel[]>();
  useEffect(() => {
    if (!data) {
      blogService.getPosts(null, 20, 0).then((posts: any) => {
        setData(posts.data);
      });
    }
  }, []);

  return (
    <Layout>
      <Container>
        <Title>
          <Message messageKey={"blog"} sectionId={MessageSections.MAIN} />
        </Title>
        <CardContentWrapper>
          {data?.map((update, index) => (
            <CardItem {...update} key={update.title + index} />
          ))}
        </CardContentWrapper>
      </Container>
    </Layout>
  );
};

export default BlogList;
